var map = {
	"./KonvaAnimation.vue": "vOn7",
	"./OrsusAdvisors.vue": "So5v",
	"./OrsusChain.vue": "t2My",
	"./OrsusChainDetails.vue": "ZRQs",
	"./OrsusEscapex.vue": "3meG",
	"./OrsusIphones.vue": "16WP",
	"./OrsusLatestNews.vue": "/ibn",
	"./OrsusNewRelease.vue": "ew9t",
	"./OrsusRippleAnimation.vue": "ZxMD",
	"./OrsusRippleAnimationBottom.vue": "42Hw",
	"./OrsusRoadmap.vue": "3tqM",
	"./OrsusSubscription.vue": "5xh9",
	"./OrsusTeamReadmore.vue": "yF0I"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "304u";